// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Linotype-DIN-Next-LT-Arabic-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Linotype-DIN-Next-LT-Arabic-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Linotype-DIN-Next-LT-Arabic-UltraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/Linotype-DIN-Next-LT-Arabic-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/Linotype-DIN-Next-LT-Arabic-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/Linotype-DIN-Next-LT-Arabic-Heavy.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/Linotype-DIN-Next-LT-Arabic-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../components/images/icon-line.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../components/images/landing-page-mob.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "DINNextLTLight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "DINNextLTRegular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "DINNextLTUltraLight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "DINNextLTMedium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "DINNextLTBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: "DINNextLTHeavy";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
  font-family: "DINNextLTBlack";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
#root {
  position: relative;
  overflow: hidden;
}

:root {
  --white-color: #ffffff;
  --white-color-obicty: #FFFFFF29;
  --black-color: #000000;
  --black-color-obicty: #00000052;
  --primary-color: #EBDD36;
  --primary-two-color: #231f20;
  --primary-three-color: #020524;
  --secondary-one-color: #32a361;
  --secondary-two-color: #e01f3d;
  --secondary-three-color: #e6cd2f;
  --secondary-four-color: #204496;
  --font-din-next-Regular: DINNextLTRegular;
  --font-din-next-Light: DINNextLTLight;
  --font-din-next-UltraLight: DINNextLTUltraLight;
  --font-din-next-Medium: DINNextLTMedium;
  --font-din-next-Heavy: DINNextLTHeavy;
  --font-din-next-Black: DINNextLTBlack;
  --font-din-next-Bold: DINNextLTBold;
  --font-heading-size: 40px;
  --font-title-size: 24px;
  --font-paragraphone-size: 24px;
  --font-paragraphtwo-size: 16px;
  --space-gap-sm: 8px;
  --space-gap-md: 16px;
  --border-radius-sm: 8px;
  --border-radius-md: 16px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  direction: rtl;
}
*:focus-visible {
  outline: none !important;
}

div, p, span, h1, h2, h3, h4, h5, h6 {
  margin: 0px;
  padding: 0px;
}

a {
  text-decoration: none !important;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}

.h-100 {
  height: 100%;
}

.w-100 {
  width: 100%;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.align-items-start {
  align-items: flex-start;
}

.align-items-end {
  align-items: flex-end;
}

.justify-content-center {
  justify-content: center;
}

.justify-content-between {
  justify-content: space-between;
}

.justify-content-around {
  justify-content: space-around;
}

.flex-column {
  flex-direction: column;
}

.flex-row {
  flex-direction: row;
}

.navbar-landing {
  padding: 25px 0px !important;
}
.navbar-landing__download {
  padding: 12px 16px;
  background-color: var(--white-color);
  display: flex;
  align-items: center;
  gap: var(--space-gap-sm);
  border-radius: var(--border-radius-sm);
  -webkit-border-radius: var(--border-radius-sm);
  -moz-border-radius: var(--border-radius-sm);
  -ms-border-radius: var(--border-radius-sm);
  -o-border-radius: var(--border-radius-sm);
}
.navbar-landing__download .text {
  font-size: 14px;
  font-weight: 500;
  color: var(--black-color);
  font-family: var(--font-din-next-Medium);
  height: 21px;
  line-height: 15px;
}
.navbar-landing__download .download {
  width: 21px;
  height: 21px;
  object-fit: cover;
}
.navbar-landing__logo {
  width: 44px;
  height: 44px;
  display: block;
}
.navbar-landing__logo .logo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (max-width: 567px) {
  .navbar-landing {
    padding: 15px 0px 25px 0px !important;
    /*
    &__download {
        display: none;
    }
    */
  }
}
.main-page {
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
}
.main-page .overlay {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(15, 15, 15, 0) -1.79%, rgba(15, 15, 15, 0.9) 113.53%);
}

.landing-page {
  height: calc(100vh - 95px);
}
.landing-page .container {
  height: 100%;
}
.landing-page__flex-container {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 20px;
  height: 100%;
  padding-bottom: 20px;
}
.landing-page__form {
  padding: 56px 40px;
  background-color: var(--black-color-obicty);
  border-radius: var(--border-radius-md);
  -webkit-border-radius: var(--border-radius-md);
  -moz-border-radius: var(--border-radius-md);
  -ms-border-radius: var(--border-radius-md);
  -o-border-radius: var(--border-radius-md);
  min-height: 571px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.landing-page__form .form__title {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-gap-sm);
}
.landing-page__form .form__title h5,
.landing-page__form .form__title p {
  color: var(--white-color);
  text-align: right;
}
.landing-page__form .form__title h5 {
  font-weight: 700;
  font-size: 25px;
  line-height: 32.5px;
  font-family: var(--font-din-next-Bold);
}
.landing-page__form .form__title P {
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  font-family: var(--font-din-next-Regular);
}
.landing-page__form .form {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
.landing-page__form ul.footerWrapper.formRelative .fmFooter {
  padding: 0px !important;
}
.landing-page__form form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.landing-page__form form .from-control {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.landing-page__form form button {
  width: 100%;
  height: 45px;
  background-color: var(--primary-color);
  border-radius: 14px;
  -webkit-border-radius: 14px;
  -moz-border-radius: 14px;
  -ms-border-radius: 14px;
  -o-border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
}
.landing-page__form form button .text {
  font-family: var(--font-din-next-Bold);
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  color: var(--black-color);
}
.landing-page__form form button:hover, .landing-page__form form button:disabled {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}
.landing-page__form form button:hover .text, .landing-page__form form button:disabled .text {
  color: #626262;
}
.landing-page__content {
  min-height: 304px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.landing-page__content__top {
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: right;
}
.landing-page__content__top .build-status {
  padding: 8px 24px;
  background-color: var(--white-color-obicty);
  border-radius: 80px;
  -webkit-border-radius: 80px;
  -moz-border-radius: 80px;
  -ms-border-radius: 80px;
  -o-border-radius: 80px;
  width: max-content;
  display: flex;
  align-items: center;
  justify-content: center;
}
.landing-page__content__top .build-status .text {
  font-family: var(--font-din-next-Medium);
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: var(--white-color);
}
.landing-page__content__top h3.title {
  font-size: 40px;
  font-family: var(--font-din-next-Bold);
  font-weight: 900;
  line-height: 48px;
  color: var(--white-color);
}
.landing-page__content__top .location {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 16px;
}
.landing-page__content__top .location .icon-location {
  width: 28px;
  height: 28px;
  object-fit: cover;
}
.landing-page__content__top .location .text {
  font-family: var(--font-din-next-Regular);
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--white-color);
}
.landing-page__content__basic-info {
  width: max-content;
  padding: 12px 24px;
  background-color: var(--white-color-obicty);
  border-radius: var(--border-radius-sm);
  -webkit-border-radius: var(--border-radius-sm);
  -moz-border-radius: var(--border-radius-sm);
  -ms-border-radius: var(--border-radius-sm);
  -o-border-radius: var(--border-radius-sm);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 32px;
  height: 83px;
}
.landing-page__content__basic-info__card {
  display: flex;
  flex-direction: row;
  gap: 16px;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  height: 100%;
}
.landing-page__content__basic-info__card__icon {
  width: 24px;
  height: 24px;
}
.landing-page__content__basic-info__card__icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.landing-page__content__basic-info__card__text {
  text-align: right;
}
.landing-page__content__basic-info__card__text h6 {
  font-size: 16px;
  font-family: var(--font-din-next-Regular);
  font-weight: 400;
  line-height: 24px;
  color: var(--white-color);
}
.landing-page__content__basic-info__card__text p {
  font-size: 18px;
  font-family: var(--font-din-next-Regular);
  font-weight: 700;
  line-height: 27px;
  color: var(--white-color);
}
.landing-page__content__basic-info__card:last-child {
  border-left: none;
  padding-left: 0px;
  margin-left: 0px;
}
.landing-page__content__basic-info__line {
  width: 1px;
  min-height: 80%;
  max-height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  opacity: 20%;
}
.landing-page__content__brind {
  width: max-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  border-radius: 5.89px;
  padding: 5.89px 8px;
  background-color: #FFFFFF;
}
.landing-page__content__brind img {
  width: 175px;
  height: 50px;
}
.landing-page__content__brind .text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #05555C;
  gap: 4px;
  border-radius: 5.89px;
  padding: 5px 15px;
}
.landing-page__content__brind .text .des {
  font-family: var(--font-din-next-Regular);
  font-weight: 400;
  font-size: 12px;
  line-height: 21px;
  color: var(--white-color);
}
.landing-page__content__brind .text .number {
  text-align: center;
  background-color: #FFFFFF;
  padding: 2px 5px;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -ms-border-radius: 3px;
  -o-border-radius: 3px;
  font-family: var(--font-din-next-Regular);
  font-weight: 700;
  font-size: 12px;
  line-height: 21px;
  color: #000000;
}
.landing-page__content__app-story {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
}
.landing-page__content__app-story h3 {
  margin-bottom: 0px;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  font-family: var(--font-din-next-Regular);
}
.landing-page__content__app-story .list {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}
.landing-page__content__app-story .list a {
  width: 150px;
  height: 44px;
}
.landing-page__content__app-story .list a img {
  width: 100%;
  height: 100%;
}
.landing-page__form-mob {
  display: none;
}

.landing-page-app-story {
  padding: 30px 0px;
  background-color: #fff;
  display: none;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap: 16px;
}
.landing-page-app-story h3 {
  margin-bottom: 0px;
  color: #1C1B13;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  font-family: var(--font-din-next-Regular);
}
.landing-page-app-story .list {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}
.landing-page-app-story .list a {
  width: 150px;
  height: 44px;
}
.landing-page-app-story .list a img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.landing-page-mob {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-position: center;
  background-size: cover;
}

@media (max-width: 992px) {
  .main-page {
    height: 80vh;
  }
  .main-page .overlay {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .landing-page {
    height: max-content;
  }
  .landing-page__flex-container {
    align-items: end;
    flex-direction: column;
    gap: 0px;
    height: 100%;
    padding-bottom: 20px;
  }
  .landing-page__form {
    padding: 20px 0px;
    background-color: transparent;
    border-radius: none;
    -webkit-border-radius: none;
    -moz-border-radius: none;
    -ms-border-radius: none;
    -o-border-radius: none;
    min-height: -moz-fit-content;
    min-height: fit-content;
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
  }
  .landing-page__form .form__title h5,
  .landing-page__form .form__title p {
    color: #1C1B13;
  }
  .landing-page__form .form__title h5 {
    font-size: 22px;
  }
  .landing-page__form .form__title P {
    font-size: 14px;
    line-height: 21px;
  }
  .landing-page__form form {
    gap: 30px;
  }
  .landing-page__form form .from-control {
    gap: 16px;
  }
  .landing-page__content {
    display: flex;
    min-height: calc(70vh - 95px);
    height: calc(70vh - 95px);
    width: 100%;
    gap: 24px;
    padding-bottom: 24px;
    justify-content: flex-end;
  }
  .landing-page__content__top {
    display: flex;
    flex-direction: column;
    gap: 8px;
    text-align: right;
  }
  .landing-page__content__top .build-status {
    padding: 8px 8px;
    height: max-content;
  }
  .landing-page__content__top h3.title {
    font-size: 22px;
    margin-bottom: 0px;
  }
  .landing-page__content__top .location {
    gap: 8px;
  }
  .landing-page__content__top .location .text {
    font-size: 14px;
  }
  .landing-page__content__basic-info {
    width: max-content;
    padding: 8px 12px;
    gap: 16px;
  }
  .landing-page__content__brind {
    gap: 2px;
    width: 100%;
    justify-content: space-between;
  }
  .landing-page__content__brind .text {
    width: 50%;
  }
  .landing-page__form-web {
    display: none;
  }
}
@media screen and (max-width: 576px) {
  .main-page {
    height: calc(100vh - 144px);
  }
  .landing-page {
    flex: 1 1;
  }
  .landing-page .container {
    height: 95%;
  }
  .landing-page__flex-container {
    justify-content: flex-end;
    padding-bottom: 0px;
    height: 100%;
  }
  .landing-page__content {
    padding-bottom: 0px;
  }
  .landing-page__content__top .location .icon-location {
    width: 16px;
    height: 16px;
  }
  .landing-page__content__basic-info {
    width: 100%;
    gap: 16px;
    padding: 8px;
    height: 60px;
  }
  .landing-page__content__basic-info__line {
    min-height: 90%;
  }
  .landing-page__content__basic-info__card {
    gap: 5px;
    flex: 1 1;
  }
  .landing-page__content__basic-info__card__text h6 {
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    width: max-content;
  }
  .landing-page__content__basic-info__card__text p {
    font-size: 14px;
    font-family: var(--font-din-next-Medium);
    font-weight: 500;
    line-height: 21px;
    width: max-content;
  }
  .landing-page__content__app-story {
    display: none;
  }
  .landing-page-app-story {
    display: flex;
    height: 144px;
  }
}
.main-page-success {
  min-height: 100vh;
  max-height: max-content;
}

.success {
  min-height: calc(100vh - 95px);
  max-height: max-content;
}
.success .container {
  height: 100%;
}
.success__flex-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  -webkit-gap: 32px;
  height: 100%;
  padding-bottom: 20px;
  -webkit-padding-bottom: 20px;
}
.success__flex-container .success-image {
  width: 160px;
  height: 160px;
}
.success__flex-container .success-image video {
  width: 100% !important;
  height: 100% !important;
}
.success__flex-container .content {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap: 32px;
}
.success__flex-container .top {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap: 16px;
}
.success__flex-container .top h6 {
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  margin-bottom: 0px;
  font-family: var(--font-din-next-Bold);
}
.success__flex-container .top p {
  font-size: 25px;
  font-weight: 400;
  line-height: 31px;
  margin-bottom: 0px;
  font-family: var(--font-din-next-Regular);
}
.success__flex-container .bottom {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap: 16px;
}
.success__flex-container .bottom p {
  margin-bottom: 0px;
  color: #807F7B;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  font-family: var(--font-din-next-Regular);
}
.success__flex-container .bottom .list {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}
.success__flex-container .bottom .list a {
  width: 162px;
  height: 48px;
}
.success__flex-container .bottom .list a img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (max-width: 567px) {
  .success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .success .container {
    height: auto;
  }
  .success__flex-container .success-image {
    width: 140px;
    height: 140px;
  }
  .success__flex-container .top h6 {
    font-size: 22px;
    line-height: 28px;
  }
  .success__flex-container .top p {
    font-size: 16px;
    line-height: 24px;
  }
  .success__flex-container .bottom p {
    font-size: 14px;
    line-height: 21px;
  }
  .success__flex-container .bottom .list {
    gap: 8px;
  }
  .success__flex-container .bottom .list a {
    width: 130px;
    height: 40px;
  }
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  background-color: #fff;
}
.loading .loading__spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.input-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.input-form label {
  font-family: var(--font-din-next-Regular);
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: var(--white-color);
  text-align: right;
  width: 100%;
  margin-bottom: 0px;
}
.input-form input {
  width: 100%;
  height: 48px;
  padding: 8px 16px;
  border-radius: var(--border-radius-sm);
  -webkit-border-radius: var(--border-radius-sm);
  -moz-border-radius: var(--border-radius-sm);
  -ms-border-radius: var(--border-radius-sm);
  -o-border-radius: var(--border-radius-sm);
  text-align: right;
  font-family: var(--font-din-next-Light);
  font-weight: 700;
  background-color: #fff !important;
}
.input-form input::placeholder {
  font-family: var(--font-din-next-Light);
  font-weight: 700;
  font-size: 14px;
  color: #807F7B;
  font-family: var(--font-din-next-Light);
}
.input-form input:focus {
  outline: none;
  border: var(--bs-border-width) solid var(--bs-border-color);
  box-shadow: none;
}
.input-form input[type=email] {
  direction: ltr;
  text-align: left;
  background-color: #fff !important;
}
.input-form input[type=email]:focus {
  background-color: #fff;
}

.form-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.form-group label {
  font-family: var(--font-din-next-Regular);
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: var(--white-color);
  text-align: right;
  width: 100%;
  margin-bottom: 0px;
}
.form-group .tel-phone {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 48px;
  background-color: var(--white-color);
  direction: ltr;
  border-radius: var(--border-radius-sm);
  border: var(--bs-border-width) solid var(--bs-border-color);
  padding: 8px 16px;
}
.form-group .tel-phone .tel-phone-code {
  font-family: var(--font-din-next-Medium);
  font-size: 14px;
  color: #242926;
  font-style: normal;
  font-weight: 500;
}
.form-group .tel-phone .line {
  width: 1px;
  height: 24px;
  background-color: #F0F0EF;
}
.form-group .tel-phone input {
  height: 100%;
  width: 100%;
  flex: 1 1;
  font-family: var(--font-din-next-Medium);
  background-color: #fff !important;
  font-size: 14px;
  color: #242926;
  font-style: normal;
  font-weight: 500;
  flex: 1 1;
  direction: ltr;
  border: var(--white-color);
}
.form-group .tel-phone input::placeholder {
  color: #a3a3a3 !important;
}

.errorfiled {
  color: #ff1010;
  font-size: 14px;
  font-family: var(--font-din-next-Regular);
  font-weight: 600;
}

.is-invalid {
  border: 2px solid red;
}

@media (max-width: 992px) {
  .input-form label,
  .form-group label {
    color: #1C1B13;
  }
}
.job-page {
  height: max-content;
  padding-bottom: 56px;
}
.job-page .job-page-hedear {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 7%;
  gap: 64px;
  background: rgba(255, 255, 255, 0.2);
  -webkit-backdrop-filter: blur(202px);
          backdrop-filter: blur(202px);
  background: linear-gradient(180deg, rgba(254, 253, 251, 0) 0%, #FEFDF9 84.62%);
}
.job-page .job-page-hedear .job-header {
  margin-bottom: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
.job-page .job-page-hedear .job-header h2 {
  color: #1C1B13;
  text-align: center;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  font-family: var(--font-din-next-Medium);
}
.job-page .job-page-hedear .job-header p {
  color: #1C1B13;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  font-family: var(--font-din-next-Regular);
}
.job-page .job-page-container {
  height: max-content;
  padding-bottom: 56px;
}
.job-page .job-page-container .container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.job-page .job-page-container .job-content {
  display: flex;
  padding: 56px 0px;
  flex-direction: column;
  align-items: center;
  gap: 56px;
  align-self: stretch;
}
.job-page .job-page-container .job-content .job-content-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.job-page .job-page-container .job-content .job-content-top h3 {
  color: #1C1B13;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  font-family: var(--font-din-next-Medium);
}
.job-page .job-page-container .job-content .job-content-top p {
  color: #1C1B13;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  font-family: var(--font-din-next-Regular);
  color: var(--Basic-Main-Text, #1C1B13);
  text-align: center;
}
.job-page .job-page-container .job-cards {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 56px;
}
.job-page .job-page-container .job-cards .job-card-line {
  height: 250px;
  width: 1px;
  opacity: 0.2;
  background: #6263AB;
}
.job-page .job-page-container .job-cards .job-card {
  display: flex;
  padding: 32px 24px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  flex: 1 0;
  align-self: stretch;
  border-radius: 16px;
  box-shadow: 0 14px 46px 0 rgba(215, 221, 224, 0.2);
}
.job-page .job-page-container .job-cards .job-card .img {
  display: flex;
  width: 80px;
  height: 80px;
  padding: 12.619px 15px;
  justify-content: center;
  align-items: center;
}
.job-page .job-page-container .job-cards .job-card .img img {
  width: 50px;
  height: 54.762px;
  flex-shrink: 0;
}
.job-page .job-page-container .job-cards .job-card .content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  align-self: stretch;
}
.job-page .job-page-container .job-cards .job-card .content h4 {
  color: #1C1B13;
  text-align: center;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  font-family: var(--font-din-next-Medium);
}
.job-page .job-page-container .job-cards .job-card .content p {
  color: #1C1B13;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  font-family: var(--font-din-next-Regular);
}
.job-page .job-page-container .job-forms {
  display: flex;
  width: 90%;
  padding: 32px;
  flex-direction: column;
  align-items: flex-end;
  gap: 32px;
  margin: 0px auto;
  border-radius: 16px;
  background: #FFF;
  box-shadow: 0 4px 20px 0 rgba(170, 170, 173, 0.12);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.job-forms {
  display: flex;
  width: 90%;
  padding: 32px;
  flex-direction: column;
  align-items: flex-end;
  gap: 32px;
  margin: 0px auto;
  border-radius: 16px;
  background: #FFF;
  box-shadow: 0 4px 20px 0 rgba(170, 170, 173, 0.12);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}
.job-forms .form-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
}
.job-forms .form-top h3 {
  color: #1C1B13;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  font-family: var(--font-din-next-Medium);
}
.job-forms .form-top p {
  color: #1C1B13;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  font-family: var(--font-din-next-Light);
}
.job-forms .form-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
}
.job-forms .form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.job-forms .form-group label {
  font-weight: 500;
  font-size: 16px;
  color: #1c1b13;
  font-family: var(--font-din-next-Regular);
}
.job-forms .form-group label span {
  color: #c43b3b;
}
.job-forms .form-group input,
.job-forms .form-group select {
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 15px;
  color: #1c1b13;
  background: #fff;
  outline: none;
  transition: 0.3s;
  font-family: var(--font-din-next-Regular);
}
.job-forms .form-group input:focus,
.job-forms .form-group select:focus {
  border-color: #6263ab;
  box-shadow: 0 0 0 2px rgba(98, 99, 171, 0.1);
}
.job-forms .form-group .tel-phone-input {
  border: none !important;
}
.job-forms .form-row {
  display: flex;
  gap: 16px;
  width: 100%;
}
.job-forms .file-group .file-area {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.job-forms .file-group .file-preview {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f8f8fa;
  padding: 10px 12px;
  border-radius: 8px;
}
.job-forms .file-group .file-preview .delete-btn {
  background: none;
  border: none;
  color: #c43b3b;
  font-size: 20px;
  cursor: pointer;
  transition: 0.3s;
}
.job-forms .file-group .file-preview .delete-btn:hover {
  transform: scale(1.1);
}
.job-forms .file-group .file-preview .file-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.job-forms .file-group .file-preview .file-info .file-name {
  font-weight: 500;
  color: #1c1b13;
}
.job-forms .file-group .file-preview .file-info .file-size {
  font-size: 13px;
  color: #807f7b;
}
.job-forms .submit-btn {
  width: 100%;
  background: #6263ab;
  color: #fff;
  padding: 12px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: 0.3s;
  font-family: var(--font-din-next-Light);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}
.job-forms .submit-btn:hover {
  background: #4f50a0;
}
.job-forms .submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #F0F0EF;
  color: #807F7B;
}
.job-forms .line {
  height: 1px;
  width: 100%;
  background: #F0F0EF;
}

.is-invalid {
  border: 2px solid #f86a6a !important;
}

.errorfiled {
  color: #f86a6a;
  font-size: 14px;
  font-family: var(--font-din-next-Regular);
  font-weight: 600;
}

.upload-box {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.upload-box input[type=file] {
  display: none;
}
.upload-box .upload-area {
  width: 100%;
  display: flex;
  padding: 12px 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  transition: 0.3s ease;
  border-radius: 8px;
  border: 1px dashed #6263AB;
  background: #F7F7FF;
  cursor: pointer;
}
.upload-box .upload-area:hover {
  background: #f3f3f8;
}
.upload-box .upload-area img {
  width: 22px;
  height: 22px;
}
.upload-box .upload-area .upload-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 0;
  font-family: var(--font-din-next-Light);
}
.upload-box .upload-area .upload-text span {
  color: #6263AB;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}
.upload-box .upload-area .upload-text small {
  color: #807F7B;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}
.upload-box .uploaded-file {
  border-radius: 8px;
  border: 1px solid #F0F0EF;
  background: #FFF;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
}
.upload-box .uploaded-file .img {
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
}
.upload-box .uploaded-file .img img {
  width: 100%;
  height: 100%;
  flex-shrink: 0;
}
.upload-box .uploaded-file .file-info {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  gap: 4px;
}
.upload-box .uploaded-file .file-info .file-name {
  color: #1C1B13;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  font-family: var(--font-din-next-Medium);
}
.upload-box .uploaded-file .file-info .file-size {
  color: #807F7B;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  font-family: var(--font-din-next-Light);
}
.upload-box .uploaded-file .delete-file {
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 50%;
  border: 0.8px solid #EF3B53;
  background: #FFF;
}
.upload-box .uploaded-file .delete-file img {
  display: flex;
  width: 17.6px;
  height: 17.6px;
  padding: 1.522px 2.203px 1.522px 2.197px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}
.upload-box .uploaded-file .delete-file:hover {
  transform: scale(1.1);
}

/* ✅ Responsive */
@media screen and (max-width: 768px) {
  .job-page {
    padding-bottom: 45px;
  }
  .job-page .job-page-hedear {
    position: relative;
    padding-top: 0%;
    gap: 15px;
  }
  .job-page .job-page-hedear header {
    position: relative;
  }
  .job-page .job-page-hedear .job-header {
    margin-bottom: 0px;
    gap: 16px;
    padding: 0px 1.5rem;
  }
  .job-page .job-page-hedear .job-header h2 {
    font-size: 24px;
  }
  .job-page .job-page-hedear .job-header p {
    font-size: 16px;
  }
  .job-page .job-page-container {
    padding-bottom: 40px;
  }
  .job-page .job-page-container .job-content {
    padding: 40px 0px;
    gap: 40px;
  }
  .job-page .job-page-container .job-content .job-content-top h3 {
    font-size: 20px;
  }
  .job-page .job-page-container .job-content .job-content-top p {
    font-size: 16px;
  }
  .job-page .job-page-container .job-cards {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 40px;
  }
  .job-page .job-page-container .job-cards .job-card-line {
    height: 1px;
    width: 100%;
  }
  .job-page .job-page-container .job-cards .job-card {
    padding: 15px;
    gap: 15px;
  }
  .job-page .job-page-container .job-cards .job-card .content h4 {
    font-size: 18px;
  }
  .job-page .job-page-container .job-cards .job-card .content p {
    font-size: 14px;
  }
  .job-page .job-page-container .job-forms {
    padding: 24px;
    gap: 24px;
    width: 100%;
  }
  .job-page .job-page-container .job-forms .form-top h3 {
    font-size: 20px;
  }
  .job-page .job-page-container .job-forms .form-row {
    flex-direction: column;
    gap: 12px;
  }
  .job-page .job-page-container .job-forms .submit-btn {
    padding: 10px;
  }
}
@media screen and (max-width: 480px) {
  .job-forms {
    padding: 20px;
  }
  .job-forms .form-top p {
    font-size: 14px;
  }
  .job-forms input,
  .job-forms select {
    font-size: 14px;
    padding: 10px 12px;
  }
  .job-forms .file-preview {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
  .job-forms .file-preview .file-info {
    font-size: 13px;
  }
}
.successjob {
  height: max-content;
  display: flex;
  flex-direction: column;
  gap: 56px;
}
.successjob header {
  position: relative;
  z-index: 1000;
}
.successjob__content {
  flex: 1 1;
  margin: 100px 0;
}
.successjob__flex-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 48px;
  align-self: stretch;
  height: 100%;
}
.successjob__flex-container .successjob-image {
  width: 160px;
  height: 160px;
}
.successjob__flex-container .successjob-image video {
  width: 100% !important;
  height: 100% !important;
}
.successjob__flex-container .content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.successjob__flex-container .content h6 {
  color: #1C1B13;
  text-align: center;
  font-family: var(--font-din-next-Medium);
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
}
.successjob__flex-container .content p {
  color: #1C1B13;
  text-align: center;
  font-family: var(--font-din-next-Light);
  font-size: 25px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}

@media screen and (max-width: 768px) {
  .successjob {
    gap: 25px;
  }
  .successjob__content {
    flex: 1 1;
    margin: 65px 0;
  }
  .successjob__flex-container {
    gap: 32px;
  }
  .successjob__flex-container .successjob-image {
    width: 120px;
    height: 120px;
  }
  .successjob__flex-container .content {
    gap: 12px;
  }
  .successjob__flex-container .content h6 {
    font-size: 28px;
  }
  .successjob__flex-container .content p {
    font-size: 20px;
  }
}
@media screen and (max-width: 480px) {
  .successjob__flex-container {
    gap: 24px;
  }
  .successjob__flex-container .successjob-image {
    width: 100px;
    height: 100px;
  }
  .successjob__flex-container .content {
    gap: 8px;
  }
  .successjob__flex-container .content h6 {
    font-size: 24px;
  }
  .successjob__flex-container .content p {
    font-size: 16px;
  }
}
.not-found {
  height: calc(100vh - 95px);
}
.not-found__flex-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 65px;
  height: 100%;
}
.not-found__flex-container .image {
  width: 397px;
  height: 300px;
}
.not-found__flex-container .image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.not-found__flex-container .content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
}
.not-found__flex-container .content .top {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
.not-found__flex-container .content .top h6 {
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  margin-bottom: 0px;
  font-family: var(--font-din-next-Bold);
  color: #1C1B13;
}
.not-found__flex-container .content .top p {
  font-size: 25px;
  font-weight: 400;
  line-height: 31px;
  margin-bottom: 0px;
  font-family: var(--font-din-next-Regular);
  color: #1C1B13;
}
.not-found__flex-container .content .btn-home {
  padding: 12px 24px;
  background-color: var(--primary-color);
  display: flex;
  align-items: center;
  gap: 8px;
}
.not-found__flex-container .content .btn-home img {
  width: 21px;
  height: 21px;
  object-fit: cover;
}
.not-found__flex-container .content .btn-home span {
  font-family: var(--font-din-next-Bold);
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: var(--black-color);
}

@media screen and (max-width: 768px) {
  .main-page.not {
    height: 100vh;
  }
  .not-found {
    height: min-content;
    padding: 24px 0px;
    margin-top: 40px;
  }
  .not-found__flex-container {
    gap: 40px;
  }
  .not-found__flex-container .image {
    width: 200px;
    height: 150px;
  }
  .not-found__flex-container .content {
    gap: 24px;
  }
  .not-found__flex-container .content .top h6 {
    font-size: 22px;
    line-height: 28px;
  }
  .not-found__flex-container .content .top p {
    font-size: 16px;
    line-height: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/main.scss","webpack://./src/style/modules/navbar.module.scss","webpack://./src/style/modules/landing-page.module.scss","webpack://./src/style/modules/success-page.module.scss","webpack://./src/style/modules/loading.module.scss","webpack://./src/style/modules/actions.module.scss","webpack://./src/style/modules/job-page.module.scss","webpack://./src/style/modules/not-found.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,6BAAA;EACA,4CAAA;AACF;AACA;EACE,+BAAA;EACA,4CAAA;AACF;AACA;EACE,kCAAA;EACA,4CAAA;AACF;AACA;EACE,8BAAA;EACA,4CAAA;AACF;AACA;EACE,4BAAA;EACA,4CAAA;AACF;AAEA;EACE,6BAAA;EACA,4CAAA;AAAF;AAEA;EACE,6BAAA;EACA,4CAAA;AAAF;AAGA;EACE,kBAAA;EACA,gBAAA;AADF;;AAIA;EACI,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,+BAAA;EAGA,wBAAA;EACA,4BAAA;EACA,8BAAA;EAEA,8BAAA;EACA,8BAAA;EACA,gCAAA;EACA,+BAAA;EAKA,yCAAA;EACA,qCAAA;EACA,+CAAA;EACA,uCAAA;EACA,qCAAA;EACA,qCAAA;EACA,mCAAA;EAMA,yBAAA;EACA,uBAAA;EACA,8BAAA;EACA,8BAAA;EAEA,mBAAA;EACA,oBAAA;EAEA,uBAAA;EACA,wBAAA;AAfJ;;AAqBA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;EACA,cAAA;AAlBJ;AAmBI;EACE,wBAAA;AAjBN;;AAoBE;EACE,WAAA;EACA,YAAA;AAjBJ;;AAoBE;EACE,gCAAA;AAjBJ;;AAmBE;EACE,aAAA;EACA,eAAA;EACA,eAAA;AAhBJ;;AAkBE;EACE,YAAA;AAfJ;;AAiBE;EACE,WAAA;AAdJ;;AAgBE;EACE,aAAA;AAbJ;;AAeE;EACE,mBAAA;AAZJ;;AAcE;EACE,uBAAA;AAXJ;;AAaE;EACE,qBAAA;AAVJ;;AAYE;EACE,uBAAA;AATJ;;AAWE;EACE,8BAAA;AARJ;;AAUE;EACE,6BAAA;AAPJ;;AASE;EACE,sBAAA;AANJ;;AAQE;EACE,mBAAA;AALJ;;AClIA;EACI,4BAAA;ADqIJ;ACnII;EACI,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,sCAAA;EACA,8CAAA;EACA,2CAAA;EACA,0CAAA;EACA,yCAAA;ADqIR;AClIQ;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,wCAAA;EACA,YAAA;EACA,iBAAA;ADoIZ;ACjIQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;ADmIZ;AC/HI;EACI,WAAA;EACA,YAAA;EACA,cAAA;ADiIR;AC/HQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;ADiIZ;;AC5HA;EACI;IACI,qCAAA;IACA;;;;KAAA;EDmIN;AACF;AEpLA;EACI,WAAA;EACA,aAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;AFsLJ;AEpLI;EACI,WAAA;EACA,YAAA;EACA,8FAAA;AFsLR;;AEjLA;EACI,0BAAA;AFoLJ;AElLI;EACI,YAAA;AFoLR;AEhLI;EACI,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;EACA,oBAAA;AFkLR;AE/KI;EACI,kBAAA;EACA,2CAAA;EACA,sCAAA;EACA,8CAAA;EACA,2CAAA;EACA,0CAAA;EACA,yCAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AFiLR;AE/KQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,wBAAA;AFiLZ;AE/KY;;EAEI,yBAAA;EACA,iBAAA;AFiLhB;AE9KY;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,sCAAA;AFgLhB;AE7KY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yCAAA;AF+KhB;AE3KQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AF6KZ;AEzKY;EACI,uBAAA;AF2KhB;AEvKQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AFyKZ;AEvKY;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AFyKhB;AEtKY;EACI,WAAA;EACA,YAAA;EACA,sCAAA;EACA,mBAAA;EACA,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AFwKhB;AEtKgB;EACI,sCAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AFwKpB;AErKgB;EAEI,sCAAA;EACA,kCAAA;AFsKpB;AEpKoB;EACI,cAAA;AFsKxB;AE9JI;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AFgKR;AE9JQ;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AFgKZ;AE9JY;EACI,iBAAA;EACA,2CAAA;EACA,mBAAA;EACA,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AFgKhB;AE9JgB;EACI,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AFgKpB;AE5JY;EACI,eAAA;EACA,sCAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AF8JhB;AE3JY;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AF6JhB;AE3JgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AF6JpB;AE1JgB;EACI,yCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AF4JpB;AEvJQ;EACI,kBAAA;EACA,kBAAA;EACA,2CAAA;EACA,sCAAA;EACA,8CAAA;EACA,2CAAA;EACA,0CAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AFyJZ;AEvJY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oCAAA;EACA,4BAAA;EACA,YAAA;AFyJhB;AEvJgB;EACI,WAAA;EACA,YAAA;AFyJpB;AEvJoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AFyJxB;AErJgB;EACI,iBAAA;AFuJpB;AErJoB;EACI,eAAA;EACA,yCAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AFuJxB;AEpJoB;EACI,eAAA;EACA,yCAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AFsJxB;AEjJgB;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;AFmJpB;AE/IY;EACI,UAAA;EACA,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,YAAA;AFiJhB;AE5IQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;AF8IZ;AE5IY;EACI,YAAA;EACA,YAAA;AF8IhB;AEzIY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,QAAA;EACA,qBAAA;EACA,iBAAA;AF2IhB;AExIgB;EACI,yCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AF0IpB;AEtIgB;EACI,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,yCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AFwIpB;AElIQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AFoIZ;AElIY;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;AFoIhB;AEjIY;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AFmIhB;AEjIgB;EACI,YAAA;EACA,YAAA;AFmIpB;AEjIoB;EACI,WAAA;EACA,YAAA;AFmIxB;AEzHI;EACI,aAAA;AF2HR;;AEtHA;EACI,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AFyHJ;AEvHI;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;AFyHR;AEtHI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AFwHR;AEtHQ;EACI,YAAA;EACA,YAAA;AFwHZ;AEtHY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AFwHhB;;AEjHA;EACI,yDAAA;EACA,2BAAA;EACA,sBAAA;AFoHJ;;AEjHA;EACI;IACI,YAAA;EFoHN;EElHM;IACI,aAAA;IACA,sBAAA;IACA,8BAAA;EFoHV;EEhHE;IACI,mBAAA;EFkHN;EEhHM;IACI,gBAAA;IACA,sBAAA;IACA,QAAA;IACA,YAAA;IACA,oBAAA;EFkHV;EE/GM;IACI,iBAAA;IACA,6BAAA;IACA,mBAAA;IACA,2BAAA;IACA,wBAAA;IACA,uBAAA;IACA,sBAAA;IACA,4BAAA;IAAA,uBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;IACA,WAAA;EFiHV;EE7Gc;;IAEI,cAAA;EF+GlB;EE5Gc;IACI,eAAA;EF8GlB;EE3Gc;IACI,eAAA;IACA,iBAAA;EF6GlB;EEzGU;IACI,SAAA;EF2Gd;EEzGc;IACI,SAAA;EF2GlB;EErGM;IACI,aAAA;IACA,6BAAA;IACA,yBAAA;IACA,WAAA;IACA,SAAA;IACA,oBAAA;IACA,yBAAA;EFuGV;EErGU;IACI,aAAA;IACA,sBAAA;IACA,QAAA;IACA,iBAAA;EFuGd;EErGc;IACI,gBAAA;IACA,mBAAA;EFuGlB;EEpGc;IACI,eAAA;IACA,kBAAA;EFsGlB;EEnGc;IACI,QAAA;EFqGlB;EEnGkB;IACI,eAAA;EFqGtB;EE/FU;IACI,kBAAA;IACA,iBAAA;IACA,SAAA;EFiGd;EE7FU;IACI,QAAA;IACA,WAAA;IACA,8BAAA;EF+Fd;EE7Fc;IACI,UAAA;EF+FlB;EEzFM;IACI,aAAA;EF2FV;AACF;AEpFA;EACI;IACI,2BAAA;EFsFN;EEnFE;IACI,SAAA;EFqFN;EEnFM;IACI,WAAA;EFqFV;EElFM;IACI,yBAAA;IACA,mBAAA;IACA,YAAA;EFoFV;EEjFM;IACI,mBAAA;EFmFV;EE9EkB;IACI,WAAA;IACA,YAAA;EFgFtB;EE3EU;IACI,WAAA;IACA,SAAA;IACA,YAAA;IACA,YAAA;EF6Ed;EE3Ec;IACI,eAAA;EF6ElB;EE1Ec;IACI,QAAA;IACA,SAAA;EF4ElB;EEzEsB;IACI,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EF2E1B;EExEsB;IACI,eAAA;IACA,wCAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EF0E1B;EElEU;IACI,aAAA;EFoEd;EE/DE;IACI,aAAA;IACA,aAAA;EFiEN;AACF;AG1qBA;EACI,iBAAA;EACA,uBAAA;AH4qBJ;;AGxqBA;EACI,8BAAA;EACA,uBAAA;AH2qBJ;AGzqBI;EACI,YAAA;AH2qBR;AGzqBI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;EACA,oBAAA;EACA,4BAAA;AH2qBR;AGzqBQ;EACI,YAAA;EACA,aAAA;AH2qBZ;AGzqBY;EACI,sBAAA;EACA,uBAAA;AH2qBhB;AGvqBQ;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AHyqBZ;AGrqBQ;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AHuqBZ;AGrqBY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sCAAA;AHuqBhB;AGpqBY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yCAAA;AHsqBhB;AGlqBQ;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AHoqBZ;AGlqBY;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;AHoqBhB;AGjqBY;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AHmqBhB;AGjqBgB;EACI,YAAA;EACA,YAAA;AHmqBpB;AGjqBoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AHmqBxB;;AGtpBA;EACI;IACI,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;EHypBN;EGxpBM;IACI,YAAA;EH0pBV;EGvpBU;IACI,YAAA;IACA,aAAA;EHypBd;EGrpBc;IACI,eAAA;IACA,iBAAA;EHupBlB;EGppBc;IACI,eAAA;IACA,iBAAA;EHspBlB;EGjpBc;IACI,eAAA;IACA,iBAAA;EHmpBlB;EGhpBc;IACI,QAAA;EHkpBlB;EGhpBkB;IACI,YAAA;IACA,YAAA;EHkpBtB;AACF;AIzyBA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AJ2yBJ;AI1yBI;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,0CAAA;EACA,kBAAA;EACA,kCAAA;AJ4yBR;AI1yBI;EACI;IAAK,uBAAA;EJ6yBX;EI5yBM;IAAO,yBAAA;EJ+yBb;AACF;;AKt0BA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;ALy0BJ;AKv0BI;EACI,yCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;ALy0BR;AKt0BI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sCAAA;EACA,8CAAA;EACA,2CAAA;EACA,0CAAA;EACA,yCAAA;EACA,iBAAA;EACA,uCAAA;EACA,gBAAA;EACA,iCAAA;ALw0BR;AKt0BQ;EACI,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,uCAAA;ALw0BZ;AKr0BQ;EACI,aAAA;EACA,2DAAA;EACA,gBAAA;ALu0BZ;AKl0BI;EACI,cAAA;EACA,gBAAA;EACA,iCAAA;ALo0BR;AKn0BQ;EACI,sBAAA;ALq0BZ;;AK/zBA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;ALk0BJ;AKh0BI;EACI,yCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;ALk0BR;AK/zBI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,oCAAA;EACA,cAAA;EACA,sCAAA;EACA,2DAAA;EACA,iBAAA;ALi0BR;AK/zBQ;EACI,wCAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;ALi0BZ;AK7zBQ;EACI,UAAA;EACA,YAAA;EACA,yBAAA;AL+zBZ;AK3zBQ;EACI,YAAA;EACA,WAAA;EACA,SAAA;EACA,wCAAA;EACA,iCAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,0BAAA;AL6zBZ;AK3zBY;EACI,yBAAA;AL6zBhB;;AKpzBA;EACI,cAAA;EACA,eAAA;EACA,yCAAA;EACA,gBAAA;ALuzBJ;;AKnzBA;EACI,qBAAA;ALszBJ;;AKlzBA;EAIQ;;IACI,cAAA;ELmzBV;AACF;AMp8BA;EACI,mBAAA;EACA,oBAAA;ANs8BJ;AMp8BI;EAEI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EAGA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,oCAAA;EACA,oCAAA;UAAA,4BAAA;EACA,8EAAA;ANq8BR;AMn8BQ;EACI,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;ANq8BZ;AMn8BY;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wCAAA;ANq8BhB;AMl8BY;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;ANo8BhB;AM/7BI;EAEI,mBAAA;EACA,oBAAA;ANg8BR;AM97BQ;EACI,YAAA;EACA,aAAA;EACA,sBAAA;ANg8BZ;AM77BQ;EACI,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AN+7BZ;AM77BY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AN+7BhB;AM77BgB;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wCAAA;AN+7BpB;AM57BgB;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,sCAAA;EACA,kBAAA;AN87BpB;AMz7BQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AN27BZ;AMz7BY;EACI,aAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;AN27BhB;AMx7BY;EACI,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,kDAAA;AN07BhB;AMx7BgB;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AN07BpB;AMx7BoB;EACI,WAAA;EACA,gBAAA;EACA,cAAA;AN07BxB;AMt7BgB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;ANw7BpB;AMt7BoB;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wCAAA;ANw7BxB;AMr7BoB;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;ANu7BxB;AMj7BQ;EACI,aAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kDAAA;EACA,mCAAA;UAAA,2BAAA;ANm7BZ;;AM76BA;EACI,aAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kDAAA;EACA,mCAAA;UAAA,2BAAA;ANg7BJ;AM96BI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;ANg7BR;AM96BQ;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wCAAA;ANg7BZ;AM76BQ;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uCAAA;AN+6BZ;AM36BI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AN66BR;AM16BI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AN46BR;AM16BQ;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,yCAAA;AN46BZ;AM16BY;EACI,cAAA;AN46BhB;AMx6BQ;;EAEI,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,yCAAA;AN06BZ;AMx6BY;;EACI,qBAAA;EACA,4CAAA;AN26BhB;AMv6BQ;EACI,uBAAA;ANy6BZ;AMr6BI;EACI,aAAA;EACA,SAAA;EACA,WAAA;ANu6BR;AMn6BQ;EACI,aAAA;EACA,sBAAA;EACA,SAAA;ANq6BZ;AMl6BQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;ANo6BZ;AMl6BY;EACI,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;ANo6BhB;AMl6BgB;EACI,qBAAA;ANo6BpB;AMh6BY;EACI,aAAA;EACA,sBAAA;EACA,QAAA;ANk6BhB;AMh6BgB;EACI,gBAAA;EACA,cAAA;ANk6BpB;AM/5BgB;EACI,eAAA;EACA,cAAA;ANi6BpB;AM35BI;EACI,WAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AN65BR;AM35BQ;EACI,mBAAA;AN65BZ;AM15BQ;EACI,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AN45BZ;AMx5BI;EACI,WAAA;EACA,WAAA;EACA,mBAAA;AN05BR;;AMt5BA;EACI,oCAAA;ANy5BJ;;AMt5BA;EACI,cAAA;EACA,eAAA;EACA,yCAAA;EACA,gBAAA;ANy5BJ;;AMt5BA;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;ANy5BJ;AMv5BI;EACI,aAAA;ANy5BR;AMt5BI;EACI,WAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,eAAA;ANw5BR;AMt5BQ;EACI,mBAAA;ANw5BZ;AMr5BQ;EACI,WAAA;EACA,YAAA;ANu5BZ;AMp5BQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;EACA,uCAAA;ANs5BZ;AMp5BY;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ANs5BhB;AMn5BY;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ANq5BhB;AM/4BI;EACI,kBAAA;EACA,yBAAA;EACA,gBAAA;EAEA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;ANg5BR;AM94BQ;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;ANg5BZ;AM94BY;EACI,WAAA;EACA,YAAA;EACA,cAAA;ANg5BhB;AM54BQ;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,QAAA;AN84BZ;AM54BY;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wCAAA;AN84BhB;AM34BY;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uCAAA;AN64BhB;AMz4BQ;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EAEA,kBAAA;EACA,2BAAA;EACA,gBAAA;AN04BZ;AMx4BY;EACI,aAAA;EACA,aAAA;EACA,cAAA;EACA,wCAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AN04BhB;AMv4BY;EACI,qBAAA;ANy4BhB;;AMn4BA,iBAAA;AACA;EACI;IACI,oBAAA;ENs4BN;EMp4BM;IACI,kBAAA;IACA,eAAA;IACA,SAAA;ENs4BV;EMp4BU;IACI,kBAAA;ENs4Bd;EMn4BU;IACI,kBAAA;IACA,SAAA;IACA,mBAAA;ENq4Bd;EMn4Bc;IACI,eAAA;ENq4BlB;EMl4Bc;IACI,eAAA;ENo4BlB;EM/3BM;IACI,oBAAA;ENi4BV;EM/3BU;IACI,iBAAA;IACA,SAAA;ENi4Bd;EM73BkB;IACI,eAAA;EN+3BtB;EM53BkB;IACI,eAAA;EN83BtB;EMz3BU;IACI,sBAAA;IACA,SAAA;IACA,mBAAA;EN23Bd;EMz3Bc;IACI,WAAA;IACA,WAAA;EN23BlB;EMx3Bc;IACI,aAAA;IACA,SAAA;EN03BlB;EMt3BsB;IACI,eAAA;ENw3B1B;EMr3BsB;IACI,eAAA;ENu3B1B;EMj3BU;IACI,aAAA;IACA,SAAA;IACA,WAAA;ENm3Bd;EMj3Bc;IACI,eAAA;ENm3BlB;EMh3Bc;IACI,sBAAA;IACA,SAAA;ENk3BlB;EM/2Bc;IACI,aAAA;ENi3BlB;AACF;AMz2BA;EACI;IACI,aAAA;EN22BN;EMz2BM;IACI,eAAA;EN22BV;EMx2BM;;IAEI,eAAA;IACA,kBAAA;EN02BV;EMv2BM;IACI,sBAAA;IACA,uBAAA;IACA,QAAA;ENy2BV;EMv2BU;IACI,eAAA;ENy2Bd;AACF;AMp2BA;EACI,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;ANs2BJ;AMp2BI;EACI,kBAAA;EACA,aAAA;ANs2BR;AMn2BI;EACI,SAAA;EACA,eAAA;ANq2BR;AMl2BI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;ANo2BR;AMl2BQ;EACI,YAAA;EACA,aAAA;ANo2BZ;AMl2BY;EACI,sBAAA;EACA,uBAAA;ANo2BhB;AMh2BQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;ANk2BZ;AM/1BY;EACI,cAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ANi2BhB;AM91BY;EACI,cAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ANg2BhB;;AMz1BA;EACI;IACI,SAAA;EN41BN;EM11BM;IACI,SAAA;IACA,cAAA;EN41BV;EMz1BM;IACI,SAAA;EN21BV;EMz1BU;IACI,YAAA;IACA,aAAA;EN21Bd;EMx1BU;IACI,SAAA;EN01Bd;EMx1Bc;IACI,eAAA;EN01BlB;EMv1Bc;IACI,eAAA;ENy1BlB;AACF;AMn1BA;EAEQ;IACI,SAAA;ENo1BV;EMl1BU;IACI,YAAA;IACA,aAAA;ENo1Bd;EMj1BU;IACI,QAAA;ENm1Bd;EMj1Bc;IACI,eAAA;ENm1BlB;EMh1Bc;IACI,eAAA;ENk1BlB;AACF;AOtkDA;EACI,0BAAA;APwkDJ;AOrkDI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;APukDR;AOrkDQ;EACI,YAAA;EACA,aAAA;APukDZ;AOrkDY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;APukDhB;AOnkDQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;APqkDZ;AOnkDY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;APqkDhB;AOnkDgB;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sCAAA;EACA,cAAA;APqkDpB;AOlkDgB;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yCAAA;EACA,cAAA;APokDpB;AO/jDY;EACI,kBAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;APikDhB;AO/jDgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;APikDpB;AO9jDgB;EACI,sCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;APgkDpB;;AOtjDA;EACI;IACI,aAAA;EPyjDN;EOvjDE;IACI,mBAAA;IACA,iBAAA;IACA,gBAAA;EPyjDN;EOtjDM;IACI,SAAA;EPwjDV;EOvjDU;IACI,YAAA;IACA,aAAA;EPyjDd;EOtjDU;IACI,SAAA;EPwjDd;EOtjDkB;IACI,eAAA;IACA,iBAAA;EPwjDtB;EOrjDkB;IACI,eAAA;IACA,iBAAA;EPujDtB;AACF","sourcesContent":["\n@font-face {\n  font-family: \"DINNextLTLight\";\n  src: url(\"./fonts/Linotype-DIN-Next-LT-Arabic-Light.ttf\")\n}\n@font-face {\n  font-family: \"DINNextLTRegular\";\n  src: url(\"./fonts/Linotype-DIN-Next-LT-Arabic-Regular.ttf\")\n}\n@font-face {\n  font-family: \"DINNextLTUltraLight\";\n  src: url(\"./fonts/Linotype-DIN-Next-LT-Arabic-UltraLight.ttf\")\n}\n@font-face {\n  font-family: \"DINNextLTMedium\";\n  src: url(\"./fonts/Linotype-DIN-Next-LT-Arabic-Medium.ttf\")\n}\n@font-face {\n  font-family: \"DINNextLTBold\";\n  src: url(\"./fonts/Linotype-DIN-Next-LT-Arabic-Bold.ttf\")\n}\n\n@font-face {\n  font-family: \"DINNextLTHeavy\";\n  src: url(\"./fonts/Linotype-DIN-Next-LT-Arabic-Heavy.ttf\")\n}\n@font-face {\n  font-family: \"DINNextLTBlack\";\n  src: url(\"./fonts/Linotype-DIN-Next-LT-Arabic-Black.ttf\")\n}\n\n#root{\n  position: relative;\n  overflow: hidden;\n}\n// \n:root {\n    --white-color: #ffffff;\n    --white-color-obicty: #FFFFFF29;\n    --black-color: #000000;\n    --black-color-obicty: #00000052;\n    //Primary colors\n    // Primary Colors\n    --primary-color: #EBDD36;\n    --primary-two-color: #231f20;\n    --primary-three-color: #020524;\n    //Secondary colors\n    --secondary-one-color: #32a361;\n    --secondary-two-color: #e01f3d;\n    --secondary-three-color: #e6cd2f;\n    --secondary-four-color: #204496;\n\n    // Font Family\n\n    \n    --font-din-next-Regular: DINNextLTRegular;\n    --font-din-next-Light: DINNextLTLight;\n    --font-din-next-UltraLight: DINNextLTUltraLight;\n    --font-din-next-Medium: DINNextLTMedium;\n    --font-din-next-Heavy: DINNextLTHeavy;\n    --font-din-next-Black: DINNextLTBlack;\n    --font-din-next-Bold: DINNextLTBold;\n\n\n\n\n    // Font Size\n    --font-heading-size: 40px;\n    --font-title-size: 24px;\n    --font-paragraphone-size: 24px;\n    --font-paragraphtwo-size: 16px;\n\n    --space-gap-sm: 8px;\n    --space-gap-md: 16px;\n\n    --border-radius-sm: 8px;\n    --border-radius-md: 16px;\n}\n\n@media (max-width: 992px) {\n  \n}\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    direction: rtl;\n    &:focus-visible {\n      outline: none !important;\n    }\n  }\n  div,p,span,h1,h2,h3,h4,h5,h6 {\n    margin: 0px;\n    padding: 0px;\n\n  }\n  a {\n    text-decoration: none !important;\n  }\n  .row {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0 -15px;\n  }\n  .h-100{\n    height: 100%;\n  }\n  .w-100{\n    width: 100%;\n  }\n  .d-flex{\n    display: flex;\n  }\n  .align-items-center{\n    align-items: center;\n  }\n  .align-items-start{\n    align-items: flex-start;\n  }\n  .align-items-end{\n    align-items: flex-end;\n  }\n  .justify-content-center{\n    justify-content: center;\n  }\n  .justify-content-between{\n    justify-content: space-between;\n  }\n  .justify-content-around{\n    justify-content: space-around;\n  }\n  .flex-column{\n    flex-direction: column;\n  }\n  .flex-row{\n    flex-direction: row;\n  }\n@import \"./modules/navbar.module.scss\";\n@import \"./modules/landing-page.module.scss\";\n@import \"./modules/success-page.module.scss\";\n@import \"./modules/loading.module.scss\";\n@import \"./modules/actions.module.scss\";\n@import \"./modules/job-page.module.scss\";\n@import \"./modules/not-found.module.scss\";",".navbar-landing {\n    padding: 25px 0px !important;\n\n    &__download {\n        padding: 12px 16px;\n        background-color: var(--white-color);\n        display: flex;\n        align-items: center;\n        gap: var(--space-gap-sm);\n        border-radius: var(--border-radius-sm);\n        -webkit-border-radius: var(--border-radius-sm);\n        -moz-border-radius: var(--border-radius-sm);\n        -ms-border-radius: var(--border-radius-sm);\n        -o-border-radius: var(--border-radius-sm);\n\n\n        .text {\n            font-size: 14px;\n            font-weight: 500;\n            color: var(--black-color);\n            font-family: var(--font-din-next-Medium);\n            height: 21px;\n            line-height: 15px;\n        }\n\n        .download {\n            width: 21px;\n            height: 21px;\n            object-fit: cover;\n        }\n    }\n\n    &__logo {\n        width: 44px;\n        height: 44px;\n        display: block;\n\n        .logo {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n        }\n    }\n}\n\n@media screen and (max-width: 567px) {\n    .navbar-landing {\n        padding: 15px 0px 25px 0px !important;\n        /*\n        &__download {\n            display: none;\n        }\n        */\n    }\n}",".main-page {\n    width: 100%;\n    height: 100vh;\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    background-position: center;\n    position: relative;\n\n    .overlay {\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(180deg, rgba(15, 15, 15, 0) -1.79%, rgba(15, 15, 15, 0.9) 113.53%);\n    }\n}\n\n\n.landing-page {\n    height: calc(100vh - 95px);\n\n    .container {\n        height: 100%;\n    }\n\n    // padding-bottom: 50px;\n    &__flex-container {\n        display: flex;\n        align-items: end;\n        justify-content: space-between;\n        gap: 20px;\n        height: 100%;\n        padding-bottom: 20px;\n    }\n\n    &__form {\n        padding: 56px 40px;\n        background-color: var(--black-color-obicty);\n        border-radius: var(--border-radius-md);\n        -webkit-border-radius: var(--border-radius-md);\n        -moz-border-radius: var(--border-radius-md);\n        -ms-border-radius: var(--border-radius-md);\n        -o-border-radius: var(--border-radius-md);\n        min-height: 571px;\n        display: flex;\n        flex-direction: column;\n        gap: 40px;\n\n        .form__title {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            gap: var(--space-gap-sm);\n\n            h5,\n            p {\n                color: var(--white-color);\n                text-align: right;\n            }\n\n            h5 {\n                font-weight: 700;\n                font-size: 25px;\n                line-height: 32.5px;\n                font-family: var(--font-din-next-Bold);\n            }\n\n            P {\n                font-weight: 400;\n                font-size: 18px;\n                line-height: 27px;\n                font-family: var(--font-din-next-Regular);\n            }\n        }\n\n        .form {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            flex: 1;\n        }\n\n        ul.footerWrapper.formRelative {\n            .fmFooter {\n                padding: 0px !important;\n            }\n        }\n\n        form {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            gap: 40px;\n\n            .from-control {\n                width: 100%;\n                display: flex;\n                flex-direction: column;\n                gap: 24px;\n            }\n\n            button {\n                width: 100%;\n                height: 45px;\n                background-color: var(--primary-color);\n                border-radius: 14px;\n                -webkit-border-radius: 14px;\n                -moz-border-radius: 14px;\n                -ms-border-radius: 14px;\n                -o-border-radius: 14px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                gap: 8px;\n                cursor: pointer;\n\n                .text {\n                    font-family: var(--font-din-next-Bold);\n                    font-weight: bold;\n                    font-size: 14px;\n                    line-height: 21px;\n                    color: var(--black-color);\n                }\n\n                &:hover,\n                &:disabled {\n                    background-color: var(--primary-color);\n                    border-color: var(--primary-color);\n\n                    .text {\n                        color: #626262;\n                    }\n                }\n            }\n\n        }\n    }\n\n    &__content {\n        min-height: 304px;\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n\n        &__top {\n            display: flex;\n            flex-direction: column;\n            gap: 16px;\n            text-align: right;\n\n            .build-status {\n                padding: 8px 24px;\n                background-color: var(--white-color-obicty);\n                border-radius: 80px;\n                -webkit-border-radius: 80px;\n                -moz-border-radius: 80px;\n                -ms-border-radius: 80px;\n                -o-border-radius: 80px;\n                width: max-content;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n\n                .text {\n                    font-family: var(--font-din-next-Medium);\n                    font-weight: 500;\n                    font-size: 14px;\n                    line-height: 21px;\n                    color: var(--white-color);\n                }\n            }\n\n            h3.title {\n                font-size: 40px;\n                font-family: var(--font-din-next-Bold);\n                font-weight: 900;\n                line-height: 48px;\n                color: var(--white-color);\n            }\n\n            .location {\n                display: flex;\n                align-items: center;\n                flex-direction: row;\n                gap: 16px;\n\n                .icon-location {\n                    width: 28px;\n                    height: 28px;\n                    object-fit: cover;\n                }\n\n                .text {\n                    font-family: var(--font-din-next-Regular);\n                    font-weight: 400;\n                    font-size: 16px;\n                    line-height: 24px;\n                    color: var(--white-color);\n                }\n            }\n        }\n\n        &__basic-info {\n            width: max-content;\n            padding: 12px 24px;\n            background-color: var(--white-color-obicty);\n            border-radius: var(--border-radius-sm);\n            -webkit-border-radius: var(--border-radius-sm);\n            -moz-border-radius: var(--border-radius-sm);\n            -ms-border-radius: var(--border-radius-sm);\n            -o-border-radius: var(--border-radius-sm);\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            gap: 32px;\n            height: 83px;\n\n            &__card {\n                display: flex;\n                flex-direction: row;\n                gap: 16px;\n                -webkit-background-clip: padding-box;\n                background-clip: padding-box;\n                height: 100%;\n\n                &__icon {\n                    width: 24px;\n                    height: 24px;\n\n                    img {\n                        width: 100%;\n                        height: 100%;\n                        object-fit: cover;\n                    }\n                }\n\n                &__text {\n                    text-align: right;\n\n                    h6 {\n                        font-size: 16px;\n                        font-family: var(--font-din-next-Regular);\n                        font-weight: 400;\n                        line-height: 24px;\n                        color: var(--white-color);\n                    }\n\n                    p {\n                        font-size: 18px;\n                        font-family: var(--font-din-next-Regular);\n                        font-weight: 700;\n                        line-height: 27px;\n                        color: var(--white-color);\n\n                    }\n                }\n\n                &:last-child {\n                    border-left: none;\n                    padding-left: 0px;\n                    margin-left: 0px;\n                }\n            }\n\n            &__line {\n                width: 1px;\n                min-height: 80%;\n                max-height: 100%;\n                background-image: url(\"../../components/images/icon-line.jpg\");\n                opacity: 20%;\n            }\n\n        }\n\n        &__brind {\n            width: max-content;\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            gap: 4px;\n            border-radius: 5.89px;\n            padding: 5.89px 8px;\n            background-color: #FFFFFF;\n\n            img {\n                width: 175px;\n                height: 50px;\n\n\n            }\n\n            .text {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                justify-content: center;\n                background-color: #05555C;\n                gap: 4px;\n                border-radius: 5.89px;\n                padding: 5px 15px;\n\n\n                .des {\n                    font-family: var(--font-din-next-Regular);\n                    font-weight: 400;\n                    font-size: 12px;\n                    line-height: 21px;\n                    color: var(--white-color);\n\n                }\n\n                .number {\n                    text-align: center;\n                    background-color: #FFFFFF;\n                    padding: 2px 5px;\n                    border-radius: 3px;\n                    -webkit-border-radius: 3px;\n                    -moz-border-radius: 3px;\n                    -ms-border-radius: 3px;\n                    -o-border-radius: 3px;\n                    font-family: var(--font-din-next-Regular);\n                    font-weight: 700;\n                    font-size: 12px;\n                    line-height: 21px;\n                    color: #000000;\n                }\n\n            }\n        }\n\n        &__app-story {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            gap: 16px;\n\n            h3 {\n                margin-bottom: 0px;\n                color: #FFFFFF;\n                font-size: 16px;\n                font-weight: 400;\n                line-height: 24px;\n                font-family: var(--font-din-next-Regular);\n            }\n\n            .list {\n                display: flex;\n                flex-direction: row;\n                align-items: center;\n                gap: 16px;\n\n                a {\n                    width: 150px;\n                    height: 44px;\n\n                    img {\n                        width: 100%;\n                        height: 100%;\n                    }\n                }\n\n            }\n\n        }\n\n    }\n\n    &__form-mob {\n        display: none;\n    }\n}\n\n\n.landing-page-app-story {\n    padding: 30px 0px;\n    background-color: #fff;\n    display: none;\n    flex-direction: column;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    gap: 16px;\n\n    h3 {\n        margin-bottom: 0px;\n        color: #1C1B13;\n        font-size: 18px;\n        font-weight: 700;\n        line-height: 24px;\n        font-family: var(--font-din-next-Regular);\n    }\n\n    .list {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 16px;\n\n        a {\n            width: 150px;\n            height: 44px;\n\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n            }\n        }\n\n    }\n}\n\n.landing-page-mob {\n    background-image: url(\"../../components/images/landing-page-mob.png\");\n    background-position: center;\n    background-size: cover;\n}\n\n@media (max-width: 992px) {\n    .main-page {\n        height: 80vh;\n\n        .overlay {\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n        }\n    }\n\n    .landing-page {\n        height: max-content;\n\n        &__flex-container {\n            align-items: end;\n            flex-direction: column;\n            gap: 0px;\n            height: 100%;\n            padding-bottom: 20px;\n        }\n\n        &__form {\n            padding: 20px 0px;\n            background-color: transparent;\n            border-radius: none;\n            -webkit-border-radius: none;\n            -moz-border-radius: none;\n            -ms-border-radius: none;\n            -o-border-radius: none;\n            min-height: fit-content;\n            display: flex;\n            flex-direction: column;\n            gap: 20px;\n            width: 100%;\n\n            .form__title {\n\n                h5,\n                p {\n                    color: #1C1B13;\n                }\n\n                h5 {\n                    font-size: 22px;\n                }\n\n                P {\n                    font-size: 14px;\n                    line-height: 21px;\n                }\n            }\n\n            form {\n                gap: 30px;\n\n                .from-control {\n                    gap: 16px;\n                }\n\n            }\n        }\n\n        &__content {\n            display: flex;\n            min-height: calc(70vh - 95px);\n            height: calc(70vh - 95px);\n            width: 100%;\n            gap: 24px;\n            padding-bottom: 24px;\n            justify-content: flex-end;\n\n            &__top {\n                display: flex;\n                flex-direction: column;\n                gap: 8px;\n                text-align: right;\n\n                .build-status {\n                    padding: 8px 8px;\n                    height: max-content;\n                }\n\n                h3.title {\n                    font-size: 22px;\n                    margin-bottom: 0px;\n                }\n\n                .location {\n                    gap: 8px;\n\n                    .text {\n                        font-size: 14px;\n                    }\n\n                }\n            }\n\n            &__basic-info {\n                width: max-content;\n                padding: 8px 12px;\n                gap: 16px;\n            }\n\n\n            &__brind {\n                gap: 2px;\n                width: 100%;\n                justify-content: space-between;\n\n                .text {\n                    width: 50%;\n                }\n            }\n\n        }\n\n        &__form-web {\n            display: none;\n        }\n    }\n\n\n}\n\n\n@media screen and (max-width: 576px) {\n    .main-page {\n        height: calc(100vh - 144px);\n    }\n\n    .landing-page {\n        flex: 1;\n\n        .container {\n            height: 95%;\n        }\n\n        &__flex-container {\n            justify-content: flex-end;\n            padding-bottom: 0px;\n            height: 100%;\n        }\n\n        &__content {\n            padding-bottom: 0px;\n\n            &__top {\n                .location {\n\n                    .icon-location {\n                        width: 16px;\n                        height: 16px;\n                    }\n                }\n            }\n\n            &__basic-info {\n                width: 100%;\n                gap: 16px;\n                padding: 8px;\n                height: 60px;\n\n                &__line {\n                    min-height: 90%;\n                }\n\n                &__card {\n                    gap: 5px;\n                    flex: 1;\n\n                    &__text {\n                        h6 {\n                            font-size: 12px;\n                            font-weight: 500;\n                            line-height: 18px;\n                            width: max-content;\n                        }\n\n                        p {\n                            font-size: 14px;\n                            font-family: var(--font-din-next-Medium);\n                            font-weight: 500;\n                            line-height: 21px;\n                            width: max-content;\n\n                        }\n                    }\n\n                }\n            }\n\n            &__app-story {\n                display: none;\n            }\n        }\n    }\n\n    .landing-page-app-story {\n        display: flex;\n        height: 144px;\n    }\n\n\n}",".main-page-success{\n    min-height: 100vh;\n    max-height: max-content;\n    \n}\n\n.success {\n    min-height: calc(100vh - 95px);\n    max-height: max-content;\n    \n    .container{\n        height: 100%;\n    }\n    &__flex-container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 32px;\n        -webkit-gap :32px;\n        height: 100%;\n        padding-bottom: 20px;\n        -webkit-padding-bottom: 20px;\n\n        .success-image {\n            width: 160px;\n            height: 160px;\n\n            video {\n                width: 100% !important;\n                height: 100% !important;\n            }\n        }\n\n        .content {\n            display: flex;\n            flex-direction: column;\n            text-align: center;\n            justify-content: center;\n            align-items: center;\n            gap: 32px;\n\n        }\n\n        .top {\n            display: flex;\n            flex-direction: column;\n            text-align: center;\n            justify-content: center;\n            align-items: center;\n            gap: 16px;\n\n            h6 {\n                font-size: 36px;\n                font-weight: 700;\n                line-height: 46px;\n                margin-bottom: 0px;\n                font-family: var(--font-din-next-Bold);\n            }\n\n            p {\n                font-size: 25px;\n                font-weight: 400;\n                line-height: 31px;\n                margin-bottom: 0px;\n                font-family: var(--font-din-next-Regular);\n            }\n        }\n\n        .bottom {\n            display: flex;\n            flex-direction: column;\n            text-align: center;\n            justify-content: center;\n            align-items: center;\n            gap: 16px;\n\n            p {\n                margin-bottom: 0px;\n                color: #807F7B;\n                font-size: 16px;\n                font-weight: 400;\n                line-height: 24px;\n                font-family: var(--font-din-next-Regular);\n            }\n\n            .list {\n                display: flex;\n                flex-direction: row;\n                align-items: center;\n                gap: 16px;\n\n                a {\n                    width: 162px;\n                    height: 48px;\n\n                    img {\n                        width: 100%;\n                        height: 100%;\n                        object-fit: cover;\n                    }\n                }\n\n            }\n\n        }\n    }\n}\n\n\n\n\n@media screen and (max-width: 567px) {\n    .success {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        .container{\n            height: auto;\n        }\n        &__flex-container {\n            .success-image {\n                width: 140px;\n                height: 140px;\n            }\n\n            .top {\n                h6 {\n                    font-size: 22px;\n                    line-height: 28px;\n                }\n\n                p {\n                    font-size: 16px;\n                    line-height: 24px;\n                }\n            }\n\n            .bottom {\n                p {\n                    font-size: 14px;\n                    line-height: 21px;\n                }\n\n                .list {\n                    gap: 8px;\n\n                    a {\n                        width: 130px;\n                        height: 40px;\n                    }\n\n                }\n\n            }\n        }\n    }\n\n}",".loading{\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.3);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    background-color: #fff;\n    .loading__spinner{\n        width: 50px;\n        height: 50px;\n        border: 5px solid #f3f3f3;\n        border-top: 5px solid var(--primary-color);\n        border-radius: 50%;\n        animation: spin 2s linear infinite;\n    }\n    @keyframes spin {\n        0% { transform: rotate(0deg); }\n        100% { transform: rotate(360deg); }\n    }\n}",".input-form {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n\n    label {\n        font-family: var(--font-din-next-Regular);\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 21px;\n        color: var(--white-color);\n        text-align: right;\n        width: 100%;\n        margin-bottom: 0px;\n    }\n\n    input {\n        width: 100%;\n        height: 48px;\n        padding: 8px 16px;\n        border-radius: var(--border-radius-sm);\n        -webkit-border-radius: var(--border-radius-sm);\n        -moz-border-radius: var(--border-radius-sm);\n        -ms-border-radius: var(--border-radius-sm);\n        -o-border-radius: var(--border-radius-sm);\n        text-align: right;\n        font-family: var(--font-din-next-Light);\n        font-weight: 700;\n        background-color: #fff !important;\n\n        &::placeholder {\n            font-family: var(--font-din-next-Light);\n            font-weight: 700;\n            font-size: 14px;\n            color: #807F7B;\n            font-family: var(--font-din-next-Light);\n        }\n\n        &:focus {\n            outline: none;\n            border: var(--bs-border-width) solid var(--bs-border-color);\n            box-shadow: none;\n\n        }\n    }\n\n    input[type=\"email\"] {\n        direction: ltr;\n        text-align: left;\n        background-color: #fff !important;\n        &:focus{\n            background-color: #fff;\n        }\n    }\n\n}\n\n.form-group {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n\n    label {\n        font-family: var(--font-din-next-Regular);\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 21px;\n        color: var(--white-color);\n        text-align: right;\n        width: 100%;\n        margin-bottom: 0px;\n    }\n\n    .tel-phone {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        height: 48px;\n        background-color: var(--white-color);\n        direction: ltr;\n        border-radius: var(--border-radius-sm);\n        border: var(--bs-border-width) solid var(--bs-border-color);\n        padding: 8px 16px;\n\n        .tel-phone-code {\n            font-family: var(--font-din-next-Medium);\n            font-size: 14px;\n            color: #242926;\n            font-style: normal;\n            font-weight: 500;\n\n        }\n\n        .line {\n            width: 1px;\n            height: 24px;\n            background-color: #F0F0EF;\n\n        }\n\n        input {\n            height: 100%;\n            width: 100%;\n            flex: 1;\n            font-family: var(--font-din-next-Medium);\n            background-color: #fff !important;\n            font-size: 14px;\n            color: #242926;\n            font-style: normal;\n            font-weight: 500;\n            flex: 1;\n            direction: ltr;\n            border: var(--white-color);\n\n            &::placeholder {\n                color: #a3a3a3 !important;\n            }\n        }\n\n    }\n\n\n}\n\n.errorfiled {\n    color: #ff1010;\n    font-size: 14px;\n    font-family: var(--font-din-next-Regular);\n    font-weight: 600;\n}\n\n\n.is-invalid {\n    border: 2px solid red;\n\n}\n\n@media (max-width: 992px) {\n\n    .input-form,\n    .form-group {\n        label {\n            color: #1C1B13;\n        }\n\n    }\n}",".job-page {\n    height: max-content;\n    padding-bottom: 56px;\n\n    .job-page-hedear {\n        // position: fixed;\n        position: relative;\n        top: 0;\n        left: 0;\n        right: 0;\n        z-index: 1000;\n        display: flex;\n        -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n        flex-direction: column;\n        align-items: center;\n        padding-top: 7%;\n        gap: 64px;\n        background: rgba(255, 255, 255, 0.20);\n        backdrop-filter: blur(202px);\n        background: linear-gradient(180deg, rgba(254, 253, 251, 0.00) 0%, #FEFDF9 84.62%);\n\n        .job-header {\n            margin-bottom: 48px;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            gap: 16px;\n\n            h2 {\n                color: #1C1B13;\n                text-align: center;\n                font-size: 32px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: 130%;\n                font-family: var(--font-din-next-Medium);\n            }\n\n            p {\n                color: #1C1B13;\n                text-align: center;\n                font-size: 18px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: 150%;\n                font-family: var(--font-din-next-Regular);\n            }\n        }\n    }\n\n    .job-page-container {\n        //  margin-top: 215px;\n        height: max-content;\n        padding-bottom: 56px;\n\n        .container {\n            height: 100%;\n            display: flex;\n            flex-direction: column;\n        }\n\n        .job-content {\n            display: flex;\n            padding: 56px 0px;\n            flex-direction: column;\n            align-items: center;\n            gap: 56px;\n            align-self: stretch;\n\n            .job-content-top {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                justify-content: center;\n                gap: 8px;\n\n                h3 {\n                    color: #1C1B13;\n                    text-align: center;\n                    font-size: 24px;\n                    font-style: normal;\n                    font-weight: 500;\n                    line-height: 130%;\n                    font-family: var(--font-din-next-Medium);\n                }\n\n                p {\n                    color: #1C1B13;\n                    text-align: center;\n                    font-size: 18px;\n                    font-style: normal;\n                    font-weight: 400;\n                    line-height: 150%;\n                    font-family: var(--font-din-next-Regular);\n                    color: var(--Basic-Main-Text, #1C1B13);\n                    text-align: center;\n                }\n            }\n        }\n\n        .job-cards {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n            gap: 10px;\n            margin-bottom: 56px;\n\n            .job-card-line {\n                height: 250px;\n                width: 1px;\n                opacity: 0.2;\n                background: #6263AB;\n            }\n\n            .job-card {\n                display: flex;\n                padding: 32px 24px;\n                flex-direction: column;\n                align-items: center;\n                gap: 24px;\n                flex: 1 0 0;\n                align-self: stretch;\n                border-radius: 16px;\n                box-shadow: 0 14px 46px 0 rgba(215, 221, 224, 0.20);\n\n                .img {\n                    display: flex;\n                    width: 80px;\n                    height: 80px;\n                    padding: 12.619px 15px;\n                    justify-content: center;\n                    align-items: center;\n\n                    img {\n                        width: 50px;\n                        height: 54.762px;\n                        flex-shrink: 0;\n                    }\n                }\n\n                .content {\n                    display: flex;\n                    flex-direction: column;\n                    align-items: center;\n                    justify-content: center;\n                    gap: 12px;\n                    align-self: stretch;\n\n                    h4 {\n                        color: #1C1B13;\n                        text-align: center;\n                        font-size: 22px;\n                        font-style: normal;\n                        font-weight: 700;\n                        line-height: 130%;\n                        font-family: var(--font-din-next-Medium);\n                    }\n\n                    p {\n                        color: #1C1B13;\n                        text-align: center;\n                        font-size: 16px;\n                        font-style: normal;\n                        font-weight: 400;\n                        line-height: 150%;\n                        font-family: var(--font-din-next-Regular);\n                    }\n                }\n            }\n        }\n\n        .job-forms {\n            display: flex;\n            width: 90%;\n            padding: 32px;\n            flex-direction: column;\n            align-items: flex-end;\n            gap: 32px;\n            margin: 0px auto;\n            border-radius: 16px;\n            background: #FFF;\n            box-shadow: 0 4px 20px 0 rgba(170, 170, 173, 0.12);\n            backdrop-filter: blur(10px);\n        }\n\n    }\n}\n\n.job-forms {\n    display: flex;\n    width: 90%;\n    padding: 32px;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 32px;\n    margin: 0px auto;\n    border-radius: 16px;\n    background: #FFF;\n    box-shadow: 0 4px 20px 0 rgba(170, 170, 173, 0.12);\n    backdrop-filter: blur(10px);\n\n    .form-top {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 8px;\n        align-self: stretch;\n\n        h3 {\n            color: #1C1B13;\n            text-align: center;\n            font-size: 24px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 130%;\n            font-family: var(--font-din-next-Medium);\n        }\n\n        p {\n            color: #1C1B13;\n            text-align: center;\n            font-size: 18px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 150%;\n            font-family: var(--font-din-next-Light);\n        }\n    }\n\n    .form-content {\n        display: flex;\n        flex-direction: column;\n        gap: 32px;\n        width: 100%;\n    }\n\n    .form-group {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        width: 100%;\n\n        label {\n            font-weight: 500;\n            font-size: 16px;\n            color: #1c1b13;\n            font-family: var(--font-din-next-Regular);\n\n            span {\n                color: #c43b3b;\n            }\n        }\n\n        input,\n        select {\n            border: 1px solid #e6e6e6;\n            border-radius: 8px;\n            padding: 12px 16px;\n            font-size: 15px;\n            color: #1c1b13;\n            background: #fff;\n            outline: none;\n            transition: 0.3s;\n            font-family: var(--font-din-next-Regular);\n\n            &:focus {\n                border-color: #6263ab;\n                box-shadow: 0 0 0 2px rgba(98, 99, 171, 0.1);\n            }\n        }\n\n        .tel-phone-input {\n            border: none !important;\n        }\n    }\n\n    .form-row {\n        display: flex;\n        gap: 16px;\n        width: 100%;\n    }\n\n    .file-group {\n        .file-area {\n            display: flex;\n            flex-direction: column;\n            gap: 12px;\n        }\n\n        .file-preview {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            background: #f8f8fa;\n            padding: 10px 12px;\n            border-radius: 8px;\n\n            .delete-btn {\n                background: none;\n                border: none;\n                color: #c43b3b;\n                font-size: 20px;\n                cursor: pointer;\n                transition: 0.3s;\n\n                &:hover {\n                    transform: scale(1.1);\n                }\n            }\n\n            .file-info {\n                display: flex;\n                flex-direction: column;\n                gap: 4px;\n\n                .file-name {\n                    font-weight: 500;\n                    color: #1c1b13;\n                }\n\n                .file-size {\n                    font-size: 13px;\n                    color: #807f7b;\n                }\n            }\n        }\n    }\n\n    .submit-btn {\n        width: 100%;\n        background: #6263ab;\n        color: #fff;\n        padding: 12px;\n        border-radius: 8px;\n        border: none;\n        cursor: pointer;\n        transition: 0.3s;\n        font-family: var(--font-din-next-Light);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 150%;\n\n        &:hover {\n            background: #4f50a0;\n        }\n\n        &:disabled {\n            opacity: 0.6;\n            cursor: not-allowed;\n            background: #F0F0EF;\n            color: #807F7B;\n        }\n    }\n\n    .line {\n        height: 1px;\n        width: 100%;\n        background: #F0F0EF;\n    }\n}\n\n.is-invalid {\n    border: 2px solid #f86a6a !important;\n}\n\n.errorfiled {\n    color: #f86a6a;\n    font-size: 14px;\n    font-family: var(--font-din-next-Regular);\n    font-weight: 600;\n}\n\n.upload-box {\n    position: relative;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n\n    input[type=\"file\"] {\n        display: none;\n    }\n\n    .upload-area {\n        width: 100%;\n        display: flex;\n        padding: 12px 8px;\n        align-items: center;\n        gap: 8px;\n        align-self: stretch;\n        transition: 0.3s ease;\n        border-radius: 8px;\n        border: 1px dashed #6263AB;\n        background: #F7F7FF;\n        cursor: pointer;\n\n        &:hover {\n            background: #f3f3f8;\n        }\n\n        img {\n            width: 22px;\n            height: 22px;\n        }\n\n        .upload-text {\n            display: flex;\n            flex-direction: column;\n            gap: 4px;\n            flex: 1 0 0;\n            font-family: var(--font-din-next-Light);\n\n            span {\n                color: #6263AB;\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: 150%;\n            }\n\n            small {\n                color: #807F7B;\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: 130%;\n            }\n        }\n\n    }\n\n    .uploaded-file {\n        border-radius: 8px;\n        border: 1px solid #F0F0EF;\n        background: #FFF;\n\n        padding: 16px;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        align-self: stretch;\n\n        .img {\n            display: flex;\n            width: 32px;\n            height: 32px;\n            justify-content: center;\n            align-items: center;\n\n            img {\n                width: 100%;\n                height: 100%;\n                flex-shrink: 0;\n            }\n        }\n\n        .file-info {\n            display: flex;\n            flex-direction: column;\n            flex: 1;\n            gap: 4px;\n\n            .file-name {\n                color: #1C1B13;\n                font-size: 14px;\n                font-style: normal;\n                font-weight: 500;\n                line-height: 150%;\n                font-family: var(--font-din-next-Medium);\n            }\n\n            .file-size {\n                color: #807F7B;\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: 130%;\n                font-family: var(--font-din-next-Light);\n            }\n        }\n\n        .delete-file {\n            display: flex;\n            width: 32px;\n            height: 32px;\n            justify-content: center;\n            align-items: center;\n            gap: 8px;\n\n            border-radius: 50%;\n            border: 0.8px solid #EF3B53;\n            background: #FFF;\n\n            img {\n                display: flex;\n                width: 17.6px;\n                height: 17.6px;\n                padding: 1.522px 2.203px 1.522px 2.197px;\n                justify-content: center;\n                align-items: center;\n                flex-shrink: 0;\n            }\n\n            &:hover {\n                transform: scale(1.1);\n            }\n        }\n    }\n}\n\n/* ✅ Responsive */\n@media screen and (max-width: 768px) {\n    .job-page {\n        padding-bottom: 45px;\n\n        .job-page-hedear {\n            position: relative;\n            padding-top: 0%;\n            gap: 15px;\n\n            header {\n                position: relative;\n            }\n\n            .job-header {\n                margin-bottom: 0px;\n                gap: 16px;\n                padding: 0px 1.5rem;\n\n                h2 {\n                    font-size: 24px;\n                }\n\n                p {\n                    font-size: 16px;\n                }\n            }\n        }\n\n        .job-page-container {\n            padding-bottom: 40px;\n\n            .job-content {\n                padding: 40px 0px;\n                gap: 40px;\n\n                .job-content-top {\n\n                    h3 {\n                        font-size: 20px;\n                    }\n\n                    p {\n                        font-size: 16px;\n                    }\n                }\n            }\n\n            .job-cards {\n                flex-direction: column;\n                gap: 10px;\n                margin-bottom: 40px;\n\n                .job-card-line {\n                    height: 1px;\n                    width: 100%;\n                }\n\n                .job-card {\n                    padding: 15px;\n                    gap: 15px;\n\n                    .content {\n\n                        h4 {\n                            font-size: 18px;\n                        }\n\n                        p {\n                            font-size: 14px;\n                        }\n                    }\n                }\n            }\n\n            .job-forms {\n                padding: 24px;\n                gap: 24px;\n                width: 100%;\n\n                .form-top h3 {\n                    font-size: 20px;\n                }\n\n                .form-row {\n                    flex-direction: column;\n                    gap: 12px;\n                }\n\n                .submit-btn {\n                    padding: 10px;\n                }\n            }\n\n        }\n    }\n\n}\n\n@media screen and (max-width: 480px) {\n    .job-forms {\n        padding: 20px;\n\n        .form-top p {\n            font-size: 14px;\n        }\n\n        input,\n        select {\n            font-size: 14px;\n            padding: 10px 12px;\n        }\n\n        .file-preview {\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 6px;\n\n            .file-info {\n                font-size: 13px;\n            }\n        }\n    }\n}\n\n.successjob {\n    height: max-content;\n    display: flex;\n    flex-direction: column;\n    gap: 56px;\n\n    header {\n        position: relative;\n        z-index: 1000;\n    }\n\n    &__content {\n        flex: 1;\n        margin: 100px 0;\n    }\n\n    &__flex-container {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 48px;\n        align-self: stretch;\n        height: 100%;\n\n        .successjob-image {\n            width: 160px;\n            height: 160px;\n\n            video {\n                width: 100% !important;\n                height: 100% !important;\n            }\n        }\n\n        .content {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            gap: 16px;\n\n\n            h6 {\n                color: #1C1B13;\n                text-align: center;\n                font-family: var(--font-din-next-Medium);\n                font-size: 36px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: 130%;\n            }\n\n            p {\n                color: #1C1B13;\n                text-align: center;\n                font-family: var(--font-din-next-Light);\n                font-size: 25px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: 130%;\n            }\n\n        }\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .successjob {\n        gap: 25px;\n\n        &__content {\n            flex: 1;\n            margin: 65px 0;\n        }\n\n        &__flex-container {\n            gap: 32px;\n\n            .successjob-image {\n                width: 120px;\n                height: 120px;\n            }\n\n            .content {\n                gap: 12px;\n\n                h6 {\n                    font-size: 28px;\n                }\n\n                p {\n                    font-size: 20px;\n                }\n            }\n        }\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .successjob {\n        &__flex-container {\n            gap: 24px;\n\n            .successjob-image {\n                width: 100px;\n                height: 100px;\n            }\n\n            .content {\n                gap: 8px;\n\n                h6 {\n                    font-size: 24px;\n                }\n\n                p {\n                    font-size: 16px;\n                }\n            }\n        }\n    }\n}",".not-found {\n    height: calc(100vh - 95px);\n\n    // padding-bottom: 50px;\n    &__flex-container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 65px;\n        height: 100%;\n\n        .image {\n            width: 397px;\n            height: 300px;\n\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n            }\n        }\n\n        .content {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            gap: 32px;\n\n            .top {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                justify-content: center;\n                gap: 16px;\n\n                h6 {\n                    font-size: 36px;\n                    font-weight: 700;\n                    line-height: 46px;\n                    margin-bottom: 0px;\n                    font-family: var(--font-din-next-Bold);\n                    color: #1C1B13;\n                }\n\n                p {\n                    font-size: 25px;\n                    font-weight: 400;\n                    line-height: 31px;\n                    margin-bottom: 0px;\n                    font-family: var(--font-din-next-Regular);\n                    color: #1C1B13;\n                }\n\n            }\n\n            .btn-home {\n                padding: 12px 24px;\n                background-color: var(--primary-color);\n                display: flex;\n                align-items: center;\n                gap: 8px;\n\n                img {\n                    width: 21px;\n                    height: 21px;\n                    object-fit: cover;\n                }\n\n                span {\n                    font-family: var(--font-din-next-Bold);\n                    font-weight: 700;\n                    font-size: 14px;\n                    line-height: 21px;\n                    color: var(--black-color);\n                }\n\n            }\n        }\n    }\n}\n\n\n\n@media screen and (max-width: 768px) {\n    .main-page.not {\n        height: 100vh;\n    }\n    .not-found {\n        height: min-content;\n        padding: 24px 0px;\n        margin-top: 40px;\n\n        // padding-bottom: 50px;\n        &__flex-container {\n            gap: 40px;\n            .image {\n                width: 200px;\n                height: 150px;\n            }\n\n            .content {\n                gap: 24px;\n                .top {\n                    h6 {\n                        font-size: 22px;\n                        line-height: 28px;\n                    }\n\n                    p {\n                        font-size: 16px;\n                        line-height: 24px;\n                    }\n                }\n            }\n        }\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
